import '../../table.less';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { TableRow } from '../../../tableRow';
import { Total, Row, TableAppearance, TableSubRow } from '../../types';
import { TableRowAppearances } from '../../../tableRow/types';
import { CoreHelper, TranslationProps, WithCoreProps } from 'ff-shared-components-core';

export interface WithLevelsTableProps {
	appearance?: TableAppearance;
	/**sets the header values */
	headers?: string[];
	/**sets the row values */
	rows?: Row[];
	/**hides the header of the table */
	withoutHeader?: boolean;
	/**Sets a checkbox prefix*/
	withCheckbox?: boolean;
	/**Sets a suffix for the table row */
	withSuffix?: boolean;
	/**Sets an image prefix for the table row */
	withImage?: boolean;
	/**set a base path to redirect on more details click */
	pathToRedirect?: string;
	/**Set the checkbox check*/
	isCheckboxChecked?: boolean;
	/**Set the row appearance */
	rowAppearance?: TableRowAppearances;
	/**Set totals*/
	totals?: Total[];
	/**Sets a message in case there is no data to show */
	noDataMessage?: string;
	/**Sets an error message in case something went wrong*/
	errorMessage?: string;
	/**flag for error message */
	hasError?: boolean;
	/** serves the purpose of catching the current selected row */
	onChange?: (items: Row[]) => void;
}

type Props = WithLevelsTableProps & RouteComponentProps & TranslationProps;

class WithLevelsTableComponent extends React.PureComponent<Props> {
	selectedRows: Row[] = [];
	render(): React.ReactNode {
		const {
			withoutHeader,
			headers,
			rows,
			withCheckbox,
			withImage,
			pathToRedirect,
			isCheckboxChecked,
			totals,
			t,
			noDataMessage = t<string>('table.noData'),
			errorMessage,
			hasError,
		} = this.props;
		return (
			<>
				<div className="ds-table table-appearance-2">
					{!withoutHeader && (
						<ul className="ds-table-cell-header">
							<li>
								{headers &&
									headers.map(
										(h: string, index: number): JSX.Element => (
											<div
												key={index}
												className={`flex-column table-${
													index + 1 >= headers.length ? 'normal' : 'big'
												}-cell`}
											>
												<span>{h}</span>
											</div>
										)
									)}
								<div className="flex-column table-small-cell"></div>
							</li>
						</ul>
					)}
					<div className="ds-table-body">
						<ul>
							{rows && rows.length !== 0 ? (
								rows.map(
									(row: Row, index: number): JSX.Element => (
										<React.Fragment key={CoreHelper.guid() || index}>
											<TableRow
												onClick={(): void => {
													this.handleOnClick(row);
												}}
												isChecked={isCheckboxChecked}
												rowId={row.id}
												pathToRedirect={pathToRedirect}
												key={CoreHelper.guid() || index}
												withImage={withImage}
												withCheckbox={withCheckbox}
												columns={row.columns}
												appearance={TableRowAppearances.secondary}
												headers={headers}
											></TableRow>

											{row.subRows &&
												row.subRows.map(
													(subRow: TableSubRow, index: number): JSX.Element => (
														<TableRow
															onClick={(): void => {
																this.handleOnClick(subRow);
															}}
															isChecked={isCheckboxChecked}
															rowId={subRow.id}
															pathToRedirect={pathToRedirect}
															key={CoreHelper.guid() || index}
															withImage={withImage}
															withCheckbox={withCheckbox}
															columns={subRow.columns}
															appearance={TableRowAppearances.subRow}
															headers={headers}
														></TableRow>
													)
												)}
										</React.Fragment>
									)
								)
							) : (
								<li className="ds-table-cell">
									<div className="ds-table-cell-detail" style={{ width: '100%' }}>
										{hasError ? errorMessage : noDataMessage}
									</div>
								</li>
							)}

							{totals && (
								<TableRow
									rowId={CoreHelper.guid()}
									totals={totals}
									appearance={TableRowAppearances.totals}
								></TableRow>
							)}
						</ul>
					</div>
				</div>
			</>
		);
	}

	private readonly handleOnClick = (selectedRow: Row): void => {
		const { onChange } = this.props;

		if (this.selectedRows.find(s => s.id === selectedRow.id)) {
			this.selectedRows.splice(
				this.selectedRows.findIndex(x => x === selectedRow),
				1
			);
		} else {
			this.selectedRows.push(selectedRow);
		}

		onChange && onChange(this.selectedRows);
	};
}

export const WithLevelsTable = WithCoreProps<WithLevelsTableProps>(withRouter(WithLevelsTableComponent));
